import React from 'react';
import { Scale } from '@nib/phi-constants';
import { StandardInfoBox } from '../info-box';
import Copy from '@nib-components/copy';
const singleMessage = 'The Australian Government Rebate offers some Australians a saving on the cost of their health cover. The percentage of this rebate is set each year and varies according to your age and taxable income.';
const coupleFamilyMessage = 'The Australian Government Rebate offers some Australians a saving on the cost of their health cover. The rebate percentage is set each year and varies based on the age of the oldest person on the policy and your combined taxable income.';
export const RebateInfoMessage = props => {
  const {
    scale,
    ...otherProps
  } = props;
  const message = scale === Scale.Single || scale === Scale.SingleParentFamily ? singleMessage : coupleFamilyMessage;
  return React.createElement(StandardInfoBox, {
    withTip: false,
    ...otherProps
  }, React.createElement(Copy, null, message));
};